import React, { useState } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/pro-solid-svg-icons";

import ModalContainer from "components/ModalContainer";

import { WorkbookType } from "../Workbook";
import { WorkbookDetailsDocument } from "../Workbook/gql/Query.generated";
import { useUpdateWorkbookMutation } from "./gql/Mutation.update.generated";

const WorkbookNameEditPanel = ({
  onDismiss,
  name,
  description,
  setName,
  setDescription,
  workbook,
}: {
  onDismiss: () => void;
  name: string;
  description: string;
  setName: (name: string) => void;
  setDescription: (desc: string) => void;
  workbook?: WorkbookType;
}) => {
  const [errorMessage, setErrorMessage] = useState("");

  const [updateWorkbook] = useUpdateWorkbookMutation();

  const handleUpdateWorkbook = () => {
    if (name === "") {
      setErrorMessage("Name is required");
      return;
    }
    updateWorkbook({
      variables: {
        workbookId: workbook.id,
        name: name,
        description: description,
      },
      refetchQueries: [
        {
          query: WorkbookDetailsDocument,
          variables: {
            workbookId: workbook.id,
            databaseId: workbook.databaseId,
          },
        },
      ],
      onError: (error) => {
        setErrorMessage(error.message);
      },
      onCompleted: () => {
        onDismiss();
      },
    });
  };

  return (
    <ModalContainer title="Edit Workbook" onClose={onDismiss} layout="centered">
      <div className="grid gap-4">
        <div className="grid gap-1">
          <div className="font-medium">Name</div>
          <input
            className="bg-white rounded border border-gray-300 box-content h-5 leading-5 px-2 py-1.5"
            type="text"
            onChange={(e) => {
              setName(e.target.value);
              setErrorMessage("");
            }}
            value={name}
            placeholder="Name of workbook"
          />
        </div>
        <div className="grid gap-1">
          <div className="font-medium">Description (Optional)</div>
          <textarea
            className="bg-white rounded border border-gray-300 box-content leading-5 px-2 py-1.5"
            onChange={(e) => {
              setDescription(e.target.value);
              setErrorMessage("");
            }}
            value={description}
            placeholder="Enter description here"
          />
        </div>
        {errorMessage && (
          <div className="text-[#C22426]">
            <FontAwesomeIcon icon={faExclamationCircle} /> {errorMessage}
          </div>
        )}
        <div>
          <button
            className="btn btn-success"
            onClick={workbook ? handleUpdateWorkbook : onDismiss}
          >
            Update
          </button>
        </div>
      </div>
    </ModalContainer>
  );
};

export default WorkbookNameEditPanel;
